import { Controller } from 'stimulus';
import { delegate } from 'utils/delegate';

/**    
< !--
  Off - canvas menu backdrop, show / hide based on off - canvas menu state.

    Entering: "transition-opacity ease-linear duration-300"
From: "opacity-0"
To: "opacity-100"
Leaving: "transition-opacity ease-linear duration-300"
From: "opacity-100"
To: "opacity-0"
-->
    <div class="fixed inset-0 bg-gray-900/80" data-target="sidebar.backdrop"></div>

    <div class="fixed inset-0 flex">
      <!--
        Off-canvas menu, show/hide based on off-canvas menu state.

        Entering: "transition ease-in-out duration-300 transform"
          From: "-translate-x-full"
          To: "translate-x-0"
        Leaving: "transition ease-in-out duration-300 transform"
          From: "translate-x-0"
          To: "-translate-x-full"
      -->
      <div class="relative mr-16 flex w-4 flex-1 -translate-x-full" data-target="sidebar.mobileMenu">
        <!--
          Close button, show/hide based on off-canvas menu state.

          Entering: "ease-in-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in-out duration-300"
            From: "opacity-100"
            To: "opacity-0"
        -->
    **/

export default class SidebarController extends Controller {
  connect() {
    this.closeTarget.addEventListener('click', this.close.bind(this));

    delegate({
      selector: '.sidebar-open-link',
      eventName: 'click',
      handler: this.open.bind(this)
    });
  }

  open(e) {
    e.preventDefault();
    this.containerTarget.classList.remove('hidden');
    this.transition('backdrop', { duration: 300, from: 'opacity-0', to: 'opacity-100' });
    this.transition('mobileMenu', { duration: 300, from: '-translate-x-full', to: 'translate-x-0' });
    this.transition('close', { duration: 300, from: 'opacity-0', to: 'opacity-100' });
  }

  close(e) {
    e.preventDefault();
    this.containerTarget.classList.add('hidden');
    this.transition('backdrop', { duration: 300, from: 'opacity-100', to: 'opacity-0' });
    this.transition('mobileMenu', { duration: 300, from: 'translate-x-0', to: '-translate-x-full' });
    this.transition('close', { duration: 300, from: 'opacity-100', to: 'opacity-0' });
  }

  transition(target, { duration, from, to }) {
    const element = this[target + 'Target'];
    element.classList.add(['transition', 'ease-in-out', 'duration-' + duration]);
    element.classList.remove(from.split(' '));
    element.classList.add(to.split(' '));
    window.setTimeout(() => {
      element.classList.remove(['transition', 'ease-in-out', 'duration-' + duration]);
    }, duration);
  }
}

SidebarController.targets = ['backdrop', 'mobileMenu', 'close', 'container'];